/**
 * product-media-play.js
 * ---------------------
 * CHANGE: new file added to ensure product video thumbnails/posters
 * are hidden when the video has loaded or starts playing.
 *
 * Behavior:
 * - On `loadeddata` (once) and on `play` we add `.is-playing` to the
 *   nearest media container and hide any <img>/.media-thumbnail inside.
 * - As a visual fallback we also set inline styles on the <video> so it
 *   consistently fills the media tile.
 *
 * Location: assets/product-media-play.js (included globally in layout)
 */

document.addEventListener('DOMContentLoaded', function () {
  const selector = '.product__media video, .product__media--video video, .media-video video, .product-media video';

  document.querySelectorAll(selector).forEach(video => {
    const mediaEl = video.closest('.product__media, .product__media--video, .media-video, .product-media');

    function hideThumbnail() {
      if (!mediaEl) return;
      // mark container so CSS can hide thumbnails via .is-playing
      mediaEl.classList.add('is-playing');
      // fallback: hide any direct <img> or thumbnail elements
      mediaEl.querySelectorAll('img, .media-thumbnail, .product-media__image').forEach(el => {
        el.style.display = 'none';
      });
    }

    // Once enough data is available to display the first frame
    video.addEventListener('loadeddata', function onLoaded() {
      hideThumbnail();
      video.removeEventListener('loadeddata', onLoaded);
    });

    // Also hide thumbnails when playback starts
    video.addEventListener('play', hideThumbnail);

    // Ensure the video fills its container regardless of inline attributes
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'cover';
  });
});